import { useRef, useState } from "react";

import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import useUsuarioFetch from "./useUsuarioFetch";
import { Usuario } from "../../types/usuario/Usuario";


type Props = {
    label: string;
    isdisabled?: boolean;
    isLoading?: boolean;
    required?: boolean;
    value?: Usuario;
    handleSearchChange: (newValue: Usuario) => void;
};


const TxtUsuario = ({
    label,
    isdisabled,
    isLoading,

    required = false,
    value,
    handleSearchChange,

}: Props) => {


    const timeoutRef = useRef<number | null>(null);
    const loading = useRef(false);




    const handleSetLoad = (newValue: boolean) => {
        loading.current = newValue;
    };

    const [inputValue, setInputValue] = useState("");
    const { options } = useUsuarioFetch({ inputValue, handleSetLoad });


    return (
        <Autocomplete
            value={value && value.id ? value : null} // 
            size="small"
            options={options}
            isOptionEqualToValue={(option, value) => option.id === value.id}

            getOptionLabel={(option) => {
                const usuario = option as Usuario;
                let descricao: string = "";

                if (!usuario) {
                    return '';
                }

                if (usuario.nome) {
                    descricao = usuario.nome;
                }

                if (usuario.cpf) {
                    descricao = "(" + usuario.cpf + ") " + descricao;
                }


                return descricao;
            }}
            loading={loading.current}

            onInputChange={(event, newInputValue) => {

                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                timeoutRef.current = window.setTimeout(() => {
                    setInputValue(newInputValue);


                }, 700); // 300ms delay
            }}

            onChange={(event, newValue) => {
                handleSearchChange(newValue as Usuario);
            }}


            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading.current ? (
                                    <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}

        />
    );








}
export default TxtUsuario;

